import { gql } from 'apollo-angular';

export class UserQueries {
  public static getNexusUser = gql`
    query nexusUserQuery($username: String!) {
      nexusUser(username: $username) {
        success
        returnValue
      }
    }
  `;
}
